<template>
  <main-layout>
    <v-container>
      <v-layout>
        <v-flex>
          <div class="headline">Broadcast</div>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn depressed color="primary" @click="showAddBroadcast = true">
            <v-icon>add</v-icon> Add Broadcast
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :pagination.sync="pagination"
        :total-items="total"
        :items="broadcasts"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>
            <v-chip
              small
              class="white--text"
              disabled
              :color="props.item.status == 'sent' ? 'success' : 'warning'"
            >
              {{ props.item.status }}</v-chip
            >
          </td>

          <td>{{ props.item.createdtime | DateFormat('DD/MM/YYYY HH:mm') }}</td>
          <td>
            <template v-if="props.item.senttime">{{
              props.item.senttime | DateFormat('DD/MM/YYYY HH:mm')
            }}</template>
            <template v-else
              >-</template
            >
          </td>
          <td>
            <v-btn
              fab
              small
              flat
              @click="
                currentBroadcast = props.item
                showEditBroadcast = true
              "
              v-if="props.item.status != 'sent'"
              ><v-icon>edit</v-icon></v-btn
            >
            <v-btn
              fab
              small
              flat
              v-else
              @click="
                currentBroadcast = props.item
                showViewBroadcast = true
              "
              ><v-icon>visibility</v-icon></v-btn
            >
            <v-btn fab small flat @click="deletebroadcast(props.item)"
              ><v-icon>delete</v-icon></v-btn
            >
          </td>
        </template>
      </v-data-table>

      <add-broadcast v-model="showAddBroadcast" @sent="addBroadcast"></add-broadcast>
      <template v-if="currentBroadcast">
        <add-broadcast
          v-model="showEditBroadcast"
          :currentbroadcast="currentBroadcast"
          @sent="editBroadcast"
          @onClose="currentBroadcast = null"
        ></add-broadcast>
      </template>

      <v-dialog v-model="showViewBroadcast" max-width="800">
        <v-card v-if="currentBroadcastFormat">
          <div class="text-xs-right">
            <v-btn small flat fab @click="showViewBroadcast = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-divider />
          <v-card-text class="font-weight-bold">
            {{ currentBroadcastFormat.name }}
          </v-card-text>
          <v-divider />
          <v-card-text>
            <div class="title mb-3">Target Customize</div>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pa-1">
                {{
                  currentBroadcastFormat.condition.fullname
                    ? currentBroadcastFormat.condition.fullname
                    : '-'
                }}</v-flex
              >
              <v-flex xs12 sm6 class="pa-1">
                {{
                  currentBroadcastFormat.condition.gender
                    ? currentBroadcastFormat.condition.gender
                    : '-'
                }}</v-flex
              >
              <v-flex xs12 sm6 class="pa-1">
                {{
                  currentBroadcastFormat.condition.datefrom
                    ? currentBroadcastFormat.condition.datefrom
                    : '-'
                }}</v-flex
              >
              <v-flex xs12 sm6 class="pa-1">
                {{
                  currentBroadcastFormat.condition.dateto
                    ? currentBroadcastFormat.condition.dateto
                    : '-'
                }}</v-flex
              >
              <v-flex xs12 class="pa-1"
                >Variables:
                {{
                  currentBroadcastFormat.condition.variables &&
                  currentBroadcastFormat.condition.variables.length > 0
                    ? currentBroadcastFormat.condition.variables.join(',')
                    : '-'
                }}
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider />
          <v-card-text>
            <div class="caption grey--text">Chatbot answers</div>
            <message-viewer v-model="currentBroadcastFormat.message"></message-viewer>

            <div class="caption grey--text mt-3">Choice</div>
            <div>
              {{ currentBroadcastFormat.quick_reply ? currentBroadcastFormat.quick_reply : '-' }}
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </main-layout>
</template>

<script>
import api from '@/api'
import AddBroadcast from './AddBroadcast'
import { mapGetters, mapMutations } from 'vuex'
import MessageViewer from '@/components/view/flow/MessageViewer'
export default {
  data() {
    return {
      showAddBroadcast: false,
      showEditBroadcast: false,
      showViewBroadcast: false,
      broadcasts: [],
      total: 0,
      loading: true,
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Create Time',
          value: 'createdtime'
        },
        {
          text: 'Sent Time',
          value: 'senttime'
        },
        {
          text: 'Action',
          sortable: false
        }
      ],
      currentBroadcast: null
    }
  },
  components: {
    AddBroadcast,
    MessageViewer
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currentBroadcastFormat() {
      if (this.currentBroadcast) {
        var data = { ...this.currentBroadcast }
        data.message = JSON.parse(data.message)
        data.condition = JSON.parse(data.condition)
        return data
      } else {
        return null
      }
    }
  },
  async mounted() {
    this.loading = true
    this.$store.dispatch('loadSetting')
    var data = await this.getbroadcast()

    this.broadcasts = data.items
    this.total = data.total
    this.loading = false
  },
  methods: {
    editBroadcast(payload) {
      if (payload.id) {
        var index = this.broadcasts.findIndex(el => {
          return el.id == payload.id
        })
        if (index != -1) {
          this.$set(this.broadcasts, index, payload)
        }
      }
    },
    addBroadcast(payload) {
      this.broadcasts.push(payload)
    },
    async getbroadcast() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      var request = {
        botorigin: this.selectedBot.pageid,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage
      }
      var response = await api.getbroadcast(request)

      if (response.data) {
        return Promise.resolve({
          items: response.data,
          total: parseInt(response.total)
        })
      } else {
        return Promise.resolve({
          items: [],
          total: 0
        })
      }
    },
    async deletebroadcast(broadcast) {
      var result = await this.$swal({
        title: 'Do you want to delete this?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var response = await api.deletebroadcast({
          botorigin: this.selectedBot.pageid,
          broadcastid: broadcast.id
        })

        if (response.responsecode == 200) {
          this.loading = true
          var data = await this.getbroadcast()

          this.broadcasts = data.items
          this.total = data.total
          this.loading = false
        }
      }
    }
  },
  watch: {
    showViewBroadcast(newVal) {
      if (newVal == false) this.currentBroadcast = null
    },
    pagination: {
      async handler() {
        this.loading = true
        var data = await this.getbroadcast()

        this.broadcasts = data.items
        this.total = data.total
        this.loading = false
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/Main.vue